import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertNewline'
})
export class ConvertNewLineToBRPipe implements PipeTransform {
    transform(value : string) : string {
        if (value) {
            return value.replace(/\n/g,'<br/>');
        }
        return ''
    }
}
